import { render, staticRenderFns } from "./HardAdminCom.vue?vue&type=template&id=2e021bcb&"
import script from "./HardAdminCom.vue?vue&type=script&lang=ts&"
export * from "./HardAdminCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports